<template>
    <b-card no-body>
        <v-table    ref="table"
                    search
                    pagination = "server"
                    :excel-callback="getExcel"
                    name="isbankasi-hgs"
                    :items-provider="provider"
                    :row-class="(item) => item.IsIgnored ? 'bg-light-danger':null"
                    :fields="fields">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-3 mb-1 mb-md-0">
                                <flat-pickr v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y', dateFormat: 'Y-m-d',mode:'range', locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>
                            </div>
                            <div class="col-md-3 mb-1 mb-md-0">
                                <select class="form-control" v-model="isIgnored">
                                    <option :value="0">Tüm Geçişler</option>
                                    <option :value="1">Yasaklı Geçişler</option>
                                    <option :value="2">Yasaklı Olmayan Geçişler</option>
                                </select>
                            </div>
                            <div class="col-md-auto col-12">
                                <button class="btn btn-success w-100" v-on:click="getByDate">
                                    Sorgula
                                </button>
                            </div>
                        </div>
                    </template>
                    <template #custom-html>
                        <div class="row px-1 py-0">
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Toplam Tutar" variant="success" icon="currency_lira" :value="stats.TotalAmountWithoutTax" short-text="Vergi Hariç"></v-stats-box>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Toplam Tutar" variant="danger" icon="currency_lira" :value="stats.TotalAmount" short-text="Vergi Dahil"></v-stats-box>
                            </div>
                            <div class="col-md-4 mb-1">
                                <v-stats-box text="Toplam Geçiş Sayısı" variant="warning" icon="local_shipping" :value="stats.TotalCount"></v-stats-box>
                            </div>
                        </div>
                    </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ReportsApi from '@/api/reports' 
import Additional from '@/utilities/additional'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import moment from 'moment'
import VStatsBox from '@/components/VStatsBox.vue'


export default {
    components:{
        BCard,
        flatPickr,
        VStatsBox
    },
    created(){
        this.dateRange = this.c_month
    },
    data(){
        return{
            dateRange:null,
            isIgnored:0,
            queryParam:null,
            fields:[
                { name:"Plaka",key:"Plate" ,sortable:true},
                { name:"HGS Numarası",key:"ProductNumber",sortable:true },
                { name:"İşlem Tipi",key:"TransactionType",sortable:true },
                { name:"Giriş Gişesi",key:"EntryPlace", sortable:true,},
                { name:"Gişe Giriş Tarihi",key:"EntryDateStr",sortable:true,sortKey:'EntryDate'},
                { name:"Çıkış Gişesi",key:"ExitPlace",sortable:true,},
                { name:"Gişe Çıkış Tarihi",key:"ExitDateStr",sortable:true,sortKey:'ExitDate'},
                { name:"İşlem Ücreti",key:"TransactionAmount",tdClass:"text-right",sortable:true, },
                { name:"İşlem Ücreti (Vergi Hariç)",key:"TransactionAmountWithoutTax",tdClass:"text-right",sortable:true,sortKey:'TransactionAmount' },
            ],
            stats:{
                TotalCount:null,
                TotalAmount:null,
                TotalAmountWithoutTax:null
            }
        }
    },
    methods:{
        getByDate(){
            this.$refs.table.refresh()
        },
        provider(data){
            this.queryParam = data.QueryParam
            this.getStats(data.QueryParam)
            return ReportsApi.IsBankasiHGS.Table(data,this.c_dates.StartDate,this.c_dates.EndDate,this.isIgnored)
        },
        getExcel(){
            this.$refs.table.setExcelLoading(true)
            ReportsApi.IsBankasiHGS.ExcelExport(this.c_dates.StartDate,this.c_dates.EndDate,this.queryParam).then(res=>{
                Additional.DownloadFile(res.data,"HGS Geçiş Verileri.xlsx")
                this.$refs.table.setExcelLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.setExcelLoading(false)
            })
        },
        getStats(searchValue){
            ReportsApi.IsBankasiHGS.StatsTransactionByBetweenDates({StartDate:this.c_dates.StartDate,EndDate:this.c_dates.EndDate,SearchParam:searchValue}).then(res=>{
                this.stats.TotalCount = res.data.Data.TotalCount
                this.stats.TotalAmount = res.data.Data.TotalAmount
                this.stats.TotalAmountWithoutTax = res.data.Data.TotalAmountWithoutTax
            })
        }
    },
    computed:{
        c_dates(){
            return {
                StartDate : this.dateRange?.split(' - ')[0] || null,
                EndDate : this.dateRange?.split(' - ')[1] || null
            }
        },
        c_month(){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [moment(firstDay).format("YYYY-MM-DD"),moment(lastDay).format("YYYY-MM-DD")].join(" - ")
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>